import { useEffect, useState } from "react";
import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { LayoutDashboard, Package, ShoppingCart, Truck, BarChart3, Users, Store, Menu, X, Percent, MapPin, KeyRound } from "lucide-react";
import { useApi } from "@/lib/useApi";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/produk", label: "Katalog Produk", icon: Package },
  { to: "/admin/pesanan", label: "Pesanan", icon: ShoppingCart },
  { to: "/admin/tarif", label: "Kelola Tarif", icon: Truck },
  { to: "/admin/pajak", label: "Pajak E-commerce", icon: Percent },
  { to: "/admin/toko", label: "Lokasi & Kontak", icon: MapPin },
  { to: "/admin/laporan", label: "Laporan Keuangan", icon: BarChart3 },
  { to: "/admin/pengguna", label: "Pengguna", icon: Users },
  { to: "/admin/akun", label: "Akun & Password", icon: KeyRound },
];

const SideNav = ({ onNavigate }) => (
  <nav className="flex flex-col gap-1">
    {NAV.map(({ to, label, icon: Icon, end }) => (
      <NavLink key={to} to={to} end={end} onClick={onNavigate} data-testid={`admin-nav-${to.split("/").pop() || "dashboard"}`}
        className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm ${isActive ? "bg-amber-50 font-medium text-amber-900" : "text-stone-600 hover:bg-stone-100"}`}>
        <Icon className="h-4 w-4" /> {label}
      </NavLink>
    ))}
    <Link to="/" className="mt-4 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-stone-500 hover:bg-stone-100" data-testid="admin-nav-store"><Store className="h-4 w-4" /> Lihat Toko</Link>
  </nav>
);

const Gate = () => {
  const call = useApi();
  const [me, setMe] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { call("get", "/me").then(setMe).catch(() => setMe({ role: "none" })); }, [call]);
  if (!me) return <p className="p-10 text-sm text-stone-500">Memuat...</p>;
  if (me.role !== "admin") return (
    <div className="p-10 text-center" data-testid="admin-access-denied">
      <p className="text-lg font-semibold">Akses ditolak</p>
      <p className="mt-1 text-sm text-stone-500">Akun {me.email} bukan admin toko.</p>
      <Link to="/" className="mt-4 inline-block text-amber-700 underline">Kembali ke toko</Link>
    </div>
  );
  return (
    <div className="min-h-screen bg-stone-50 lg:grid lg:grid-cols-[240px_1fr]">
      <aside className="hidden border-r border-stone-200 bg-white p-4 lg:block">
        <p className="mb-6 px-3 font-semibold">EllMom Master Admin</p>
        <SideNav />
      </aside>
      <div className="min-w-0">
        <header className="flex items-center gap-3 border-b border-stone-200 bg-white px-4 py-3 lg:px-8">
          <button className="lg:hidden" data-testid="admin-menu-toggle" onClick={() => setOpen(!open)}>{open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</button>
          <p className="font-semibold lg:hidden">Master Admin</p>
          <div className="ml-auto flex items-center gap-3"><span className="hidden text-sm text-stone-500 sm:inline">{me.email}</span><UserButton /></div>
        </header>
        {open && <div className="border-b border-stone-200 bg-white p-4 lg:hidden"><SideNav onNavigate={() => setOpen(false)} /></div>}
        <main className="mx-auto max-w-7xl p-4 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
};

export default function AdminLayout() {
  return (
    <>
      <Show when="signed-in"><Gate /></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}

export const PageHeader = ({ title, children }) => (
  <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
    <h1 className="text-2xl font-semibold">{title}</h1>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
